export default __webpack_public_path__ + "static/1135-7356aab1a06f76e431b8649e96c3cd52.gif";